import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { lastValueFrom, Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { dasa } from '../../classess/dasaClasses';

@Injectable({
  providedIn: 'root'
})

export class commonService {

  private subject = new Subject<any>();
  private isStoreClosed = new Subject<boolean>();

  constructor(private http: HttpClient) { }
  
  sendMessage(message: string) {
    this.subject.next(message)
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
  clearMessages() {
    this.subject.next;
  }

  doAPICall(request: any, url: string): Observable<any> {
    return this.http.post(url, request)
      .pipe(catchError(this.formatErrors))
  }
  postCallParameters(url: string): Observable<any> {
    return this.http.post(url,{})
      .pipe(catchError(this.formatErrors))
  }

  doAPICall_await(request: any, url: string) {
    return lastValueFrom(this.http.post(url, request));
  }

  private formatErrors(error: any) {
    return throwError(error.error)
  }

  getDeliveryCharges(request: any, url: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': 'Basic YWRtaW46YWRtaW4xMjM=',
     'Content-Type': 'application/json',
    });

    const options = { headers: headers };
    return this.http.post(url, request, options)
      .pipe(catchError(this.formatErrors))
  }

  getStoreStatus(): Observable<boolean> {
    return this.isStoreClosed.asObservable();
  }

  setStoreStatus(status: boolean): void {
    this.isStoreClosed.next(status);
  }
}
